import { Moves } from "../constants/actionType";

const initialState = {
    moveLandingExp: null,
    checkoutLandingExp: null,
    faqMoveLandingContent: '',
    updateCartFlow: false,
    cust_opt: null,
    isMoveLandingPage: false
}

function moveExp(state = initialState, action)
{
    switch (action.type) {
        case "MOVE_LANDING":
            return Object.assign({}, state, {
                moveLandingExp: action.value
            })
        case "MOVE_LANDINGFROMJSON":
            return Object.assign({}, state, {
                moveLandingExp: action.value
            })
        case "FAQ_MOVELANDING_CONTENT":
            return Object.assign({}, state, {
                faqMoveLandingContent: action.value
            })
        case "UPDATE_CART_FLOW":
            return Object.assign({}, state, {
                updateCartFlow: action.value
            })
        case "TN_OPT":
            return Object.assign({}, state, {
                TN_OPT: action.value
            })
        case Moves.UPDATE_CUST_OPT:
            return Object.assign({}, state, {
                cust_opt: action.value
            })
        case "MOVE_LANDING_PAGE":
            return Object.assign({}, state, {
                isMoveLandingPage: action.value
            })
        default:
            return state
    }
}
export default moveExp